// --- Request Processors

import { parseJSON } from '../../helpers'

export function normaliseFacets(facets) {
  return facets.map((facet) => {
    return {
      ...facet,
      values: facet.values.filter((item) => item.value !== '"')
    }
  })
}

export function normaliseSortOptions(options) {
  return options.map((option) => {
    return {
      ...option,
      active: option.active ?? 0
    }
  })
}

export function normaliseSwatches(result) {
  const parsedSwatches = parseJSON(result?.mfield_dotapparel21_siblings, 'array')
  return (
    parsedSwatches
      // .filter((swatch) => swatch.published) -- TODO: Reenable this when the products are published
      .sort((swatchA, swatchB) => {
        if (swatchA.isCurrent === swatchB.isCurrent) return 0
        if (swatchA.isCurrent) return -1
        return 1
      })
  )
}

export function normaliseImages(result) {
  //   Image handling
  const alts = result?.images_alt?.split('|') ?? []
  const srcs = result?.images ?? []

  return srcs.map((src, index) => {
    return {
      src,
      alt: alts[index]
    }
  })
}

export function normaliseResults(results) {
  return results.map((result) => {
    const swatches = normaliseSwatches(result)
    const images = normaliseImages(result)
    const variants = parseJSON(result.variants, 'array')

    return {
      ...result,
      images,
      swatches,
      variants
    }
  })
}

export function normaliseRecommendations(results) {
  return results?.results?.map((result) => {
    const swatches = normaliseSwatches(result)
    const variants = parseJSON(result.attributes.variants, 'array')
    const images = normaliseImages(result.attributes)

    return {
      ...result,
      ...result.attributes,
      ...result.mappings.core,
      images,
      swatches,
      variants
    }
  })
}
